import { useEffect, useState } from "react"
import { Alert, Button, Col, Form, Row } from "react-bootstrap"
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from "zod"
import { EmpresasService } from "../../../services/api/Empresas/EmpresasService"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Loading from "../../../components/Loader/Loading"
import ConfiguracoesSistemaPrincipal from "../ConfiguracoesSistemaPrincipal"
import { usePermissoes } from "../../../hooks/usePermissoes"
import { faSpinner } from "@fortawesome/free-solid-svg-icons"


const BASE_URL = process.env.REACT_APP_BASE_URL;

const scheme = z.object({
    empresasId: z.coerce.string(),
    habilitaAgenda: z.coerce.string(),
    urlAgenda: z.coerce.string()

})
const AgendaOnlineCadEdit = () => {
    const [empresa, setEmpresa] = useState(null)
    const { register, handleSubmit, getValues, watch, formState: { errors } } = useForm({
        mode: 'onBlur',
        resolver: zodResolver(scheme),
        values: empresa
    })

    const urlExemplo = watch('urlAgenda')
    const [alert, setAlert] = useState({ tipo: null, msg: null, show: false })

    const [disableSalvar, setDisableSalvar] = useState(false)
    const [isLoading, setIsloading] = useState(true)
    const { listPermissoes } = usePermissoes([
        { secoesId: 8, acoesId: 1 },
        { secoesId: 8, acoesId: 2 },
        { secoesId: 8, acoesId: 3 },
    ])

    const onSubmit = async (data) => {
        setDisableSalvar(true)
        let DataForm = data

        const res = await EmpresasService.storeEmpresaAgenda(data.empresasId, DataForm)

        if (res.success) {
            setAlert({ tipo: 'success', msg: 'Salvo com sucesso!', show: true })
        } else {
            setAlert({ tipo: 'danger', msg: 'res.msg', show: true })
        }

        setDisableSalvar(false)
    }



    useEffect(() => {

        const fetchData = async () => {
            setIsloading(true);
            const data = await EmpresasService.getAll()

            const empresaData = data.data[0]


            const cli = await EmpresasService.getEmpresaAgenda(empresaData.id)

            if (cli.data == null) {
                setEmpresa({
                    ...empresa,
                    empresasId: empresaData.id,
                    habilitaAgenda: '0'

                })
            } else {
                setEmpresa({
                    ...cli.data,
                    empresasId: empresaData.id,
                    habilitaAgenda: cli.data?.habilitaAgenda.toString()
                })
            }

            setIsloading(false);
        }
        fetchData()



    }, [])
    useEffect(() => {

    }, [urlExemplo])



    console.log(urlExemplo)
    console.log(errors)
    return (

        <ConfiguracoesSistemaPrincipal>
            <>



                <h3><span className="text-primary">Configurações da Agenda Online </span> </h3>
                <h4 className="text-primary"></h4>
                <hr></hr>

                {(isLoading) ? <Loading /> : (
                    <>
                        <div style={{ maxWidth: '800px' }}>


                            <Form>
                                <Row>
                                    <Form.Group as={Col} sm={6}>
                                        <Form.Label className="mr-10">Habilitar agenda online?</Form.Label>
                                        <Form.Check
                                            inline
                                            type="radio"
                                            label="Não"
                                            value="0"
                                            {...register('habilitaAgenda')}
                                        ></Form.Check>

                                        <Form.Check
                                            inline
                                            type="radio"
                                            label="Sim"
                                            value="1"
                                            {...register('habilitaAgenda')}
                                        ></Form.Check>
                                    </Form.Group>
                                </Row>
                                <Row>
                                    <Form.Group as={Col} controlId="formUf">
                                        <Form.Label>Url do site:<br></br>

                                        </Form.Label>
                                        <Form.Control type="text" placeholder="Url"
                                            {...register('urlAgenda')} >
                                        </Form.Control>
                                        <span>
                                            {BASE_URL + urlExemplo}
                                        </span>

                                    </Form.Group>
                                </Row>

                                <br></br>
                                <Alert variant={alert?.tipo} show={alert?.show} className="text-center">
                                    {alert?.msg}
                                </Alert>




                                <div className="text-center "  >
                                    {(listPermissoes?.cadastrar) ?
                                        <Button variant="primary"
                                        disabled={disableSalvar}
                                            size="sm" onClick={() => handleSubmit(onSubmit)()}>
                                        
                                            {(disableSalvar) ? <>
                                                <FontAwesomeIcon icon={faSpinner} spin /> Salvando...
                                            </> : 'Salvar'}</Button> : ''}
                                </div>
                            </Form>
                        </div>
                    </>)}

            </>

        </ConfiguracoesSistemaPrincipal>
    )
}
export default AgendaOnlineCadEdit